import React from 'react';
import styles from './Table.module.css';

const Table = ({
  columns,
  data,
  loading,
  emptyMessage = 'No data available',
  selectable = false,
  selectedIds = [],
  onToggleRow,
  onToggleAll,
  rowIdKey = 'id',
}) => {
  if (loading) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner} />
        <p>Loading...</p>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className={styles.empty}>
        <p>{emptyMessage}</p>
      </div>
    );
  }

  const selectedSet = new Set(selectedIds);
  const allChecked = data.length > 0 && data.every((row) => selectedSet.has(row[rowIdKey]));
  const someChecked = !allChecked && data.some((row) => selectedSet.has(row[rowIdKey]));

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            {selectable && (
              <th style={{ width: 40 }}>
                <input
                  type="checkbox"
                  className={styles.checkbox}
                  checked={allChecked}
                  ref={(el) => {
                    if (el) el.indeterminate = someChecked;
                  }}
                  onChange={(e) => onToggleAll && onToggleAll(e.target.checked)}
                  aria-label="Select all"
                />
              </th>
            )}
            {columns.map((column) => (
              <th key={column.key} style={{ width: column.width }}>
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            const id = row[rowIdKey] ?? index;
            const isSelected = selectedSet.has(id);
            return (
              <tr key={id} className={isSelected ? styles.selected : ''}>
                {selectable && (
                  <td>
                    <input
                      type="checkbox"
                      className={styles.checkbox}
                      checked={isSelected}
                      onChange={(e) => onToggleRow && onToggleRow(id, e.target.checked, row)}
                      aria-label="Select row"
                    />
                  </td>
                )}
                {columns.map((column) => (
                  <td key={column.key}>
                    {column.render ? column.render(row[column.key], row) : row[column.key]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
